module.exports = __webpack_public_path__ + "img/DA.8db09f58.jpg";